import TrelloModel from 'app/scripts/models/internal/trello-model.coffee';

class PendingOrganization extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'PendingOrganization';
  }
}
PendingOrganization.initClass();

export { PendingOrganization };
